import { render, staticRenderFns } from "./clippingMasks.vue?vue&type=template&id=4948a531&scoped=true&"
import script from "./clippingMasks.vue?vue&type=script&lang=js&"
export * from "./clippingMasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4948a531",
  null
  
)

export default component.exports